import { render, staticRenderFns } from "./WorkSearch.vue?vue&type=template&id=4b5e9dec&"
import script from "./WorkSearch.vue?vue&type=script&lang=js&"
export * from "./WorkSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports